import {ProductsRelDocs} from "../../interfaces";
interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    classEx?: string,
    sourceCode?:string,
    isGoogleShoppingFeed?: boolean,
}
/**
 * the entry point
 */
const PRDPriceNote = (props: IProductBuyButtonProps) => {

    const product = props.product;
    const sourceCode = props.sourceCode;
    const classEx = props.classEx ?? " justify-start";
    let productNote  = sourceCode === 'sticky-menu' ? product.note.replace('class="w-btn"','class="w-btn inline-block w-auto px-12 "') : product.note;

    return (

            <>
                {
                        <div className={`price-note ${sourceCode} w-full flex flex-wrap justify-center`}>
                        <div className={"w-full flex " + classEx} dangerouslySetInnerHTML={{ __html: productNote }} />
                        </div>

                }
            </>
    )
};

export default PRDPriceNote;